import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

export default (rootReducer, rootSaga) => {
    // create the saga middleware
    const sagaMiddleware = createSagaMiddleware();

    // create a redux store with our reducer above and middleware
    /* eslint-disable no-underscore-dangle */
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const store = createStore(
        rootReducer,
        composeEnhancers(applyMiddleware(sagaMiddleware))
    );

    // kick off root saga
    sagaMiddleware.run(rootSaga);

    return store;
};
